import type WhiteboardController from '../controllers/WhiteboardController';
import { type CustomShape } from '../models/CustomShape';
import StylusCustomShape from '../stylus/StylusCustomShape';
import type ClientBase from './ClientBase';
import DataStore from './DataStore';

export class DataStoreCustomShapes extends DataStore<CustomShape> {
  constructor(
    tableKey: string,
    client: ClientBase,
    private readonly onCustomShapeChanged: (
      change: 'added' | 'removed',
      customShape: CustomShape
    ) => void
  ) {
    super(tableKey, client);
  }

  addRecord(record: CustomShape): CustomShape {
    super.addRecord(record);
    this.onCustomShapeChanged('added', record);
    return record;
  }

  removeRecord(record: CustomShape): void {
    super.removeRecord(record);
    this.onCustomShapeChanged('removed', record);
  }
}

/** Creates a `DataStoreCustomShapes` for `WhiteboardController`
 * and keeps the controllers list of `StylusCustomShape`s synced
 * with the datastore */
export function createDataStoreCustomShapes(
  whiteboardController: WhiteboardController
) {
  return new DataStoreCustomShapes(
    'customShapes',
    whiteboardController.client,
    (change, customShape) => {
      switch (change) {
        case 'added':
          whiteboardController.customShapesStyluses.push(
            new StylusCustomShape({
              controller: whiteboardController,
              customShape,
            })
          );
          whiteboardController.customShapesStyluses.sort((a, b) =>
            a.customShape.name.localeCompare(b.customShape.name)
          );
          break;
        case 'removed': {
          whiteboardController.customShapesStyluses.splice(
            whiteboardController.customShapesStyluses.findIndex(
              stylus => stylus.customShape.id === customShape.id
            ),
            1
          );
          break;
        }
        default: {
          const _exhaustivenessCheck: never = change;
        }
      }
    }
  );
}
